/**
 * スクリーニング 株価チャート表示
 */
import $ from 'jquery';
import moment from 'moment';
import Highcharts from 'highcharts/highstock';
import HighchartsMore from "highcharts/highcharts-more.js"
import Indicators from 'highcharts/indicators/indicators-all';
import { chartLib } from '../../common/ChartLibrary';

HighchartsMore(Highcharts);
Indicators(Highcharts);

export default class StockIndexChart {

    constructor(stockCd) {
        this.stockCd = stockCd;
        this.divId = 'chart_' + stockCd;
        this.chart = null;
    }

    /**
     * チャートを初期化
     *
     * @param {type} periodId
     * @returns {undefined}
     */
    initChart(periodId) {
        const dataParam = this.getDataParam(periodId);

        $.ajax({
            url: $('#stockPriceJsonBaseUrl').val() + this.stockCd + '.json',
            dataType: 'jsonp',
            jsonpCallback: 'stock_price' + this.stockCd,
            async: false
        })
        .done((jsonDate) => {
            let series = jsonDate['chart'][dataParam.type];

            // チャート生成
            this.chart = this.createChart(series);

            //出来高を非表示
            this.chart.series[7].hide();

            // 表示期間初期値設定
            this.setChartRange(4);
        })
        .fail(() => {
            $('#' + this.id).html('読み込みに失敗しました');
        });
    }

    getDataParam(periodId) {
        let type = null,

        parsedPeriodId = parseInt(periodId);

        switch (periodId) {
            // 日足
            case 2:
                type = 'daily';
                break;
            // 週足
            case 3:
                type = 'weekly';
                break;
            // 月足
            case 4:
                type = 'monthly';
                break;
            default:
        }

        return {
            type: type,
            selected: parsedPeriodId
        };
    }

    /**
     * グラフ生成
     *
     * @param {type} series
     *
     * @returns {object} chart
     */
    createChart(series) {
        Highcharts.setOptions({
            lang: {
                // 縦軸の数値にカンマ表示
                thousandsSep: ',',
                rangeSelectorZoom: '',
                // 表示データが無い時のメッセージ
                noData: '選択されているデータはありません',
                // ロード中メッセージ
                loading: '読み込み中'
            },
            global : {
                // 表示をUTCからローカルタイムにする
                useUTC: false
            }
        });

        return Highcharts.stockChart(this.divId , {
            chart: {
                style: {
                    fontFamily: $('#fontFamily').val()
                },
                panning: false,
                marginBottom: 25,
                marginTop: 9,
                spacingRight: 5,
                marginLeft: 5,
                animation: false
            },
            title: {
                text: null
            },
            navigator : {
                enabled : false
            },
            scrollbar: {
                enabled: false
            },
            rangeSelector: {
                enabled: false
            },
            //横軸
            xAxis: {
                title: {
                    text: null
                },
                type: 'datetime',
                dateTimeLabelFormats: {
                    day: '%m/%d',
                    week: '%m/%d',
                    month: '%Y/%m',
                    year: '%Y'
                },
                opposite: false,
                ordinal: true,
                gridLineColor: '#ccc',
                gridLineWidth: 1,
                tickmarkPlacement: 'on',
                tickPosition: 'outside',
                tickPixelInterval: 110,
                minPadding: 0,
                maxPadding: 0,
                tickLength: 6,
                labels: {
                    style: {
                        color: '#000'
                    }
                },
                crosshair: {
                    width: 1,
                    zIndex: 5
                }
            },
            //縦軸
            yAxis: [{
                title: {
                    text: null
                },
                labels: {
                    enabled: false
                },
                opposite: true,
                gridLineColor: '#ccc',
                gridLineWidth: 1,
                gridLineDashStyle: 'solid',
                lineWidth: 1,
                lineColor: '#ccc',
                tickLength: 5,
                tickWidth: 1,
                tickColor: '#ccc',
                tickAmount: 7,
                showLastLabel: true,
                showFirstLabel: true,
                tickPositioner: function () {
                    //tick値を計算する
                    return chartLib.calcTickPositions(this, 5);
                }
            }, {
                enabled: false
            }],
            tooltip: {
                dateTimeLabelFormats: {
                    day: '%Y/%m/%d',
                    week: '%Y/%m/%d',
                    month: '%Y/%m',
                    year: '%Y/%m'
                },
                style: {
                    fontSize: '11px'
                },
                valueSuffix: '',
                hideDelay: 150, // ms
                shared: true,
                split: false,
                useHTML: true,
                positioner: function (boxWidth, boxHeight, point) {
                    return chartLib.tooltipPositioner(this, boxWidth, boxHeight, point);
                },
                formatter: function () {
                    let symbol = '●',
                        xDatetime = Highcharts.dateFormat('%Y/%m/%d %H:%M', new Date(this.x)),
                        tooltip = '<table style="width: 100%; display: table;"><tr><td colspan="2">' + xDatetime.replace(/\s00:00$/, '') + '</td></tr>',
                        tooltipBottom = '',
                        period,
                        // 数値部分のスタイル
                        numStyle = 'font-weight: bold;';

                    $.each(this.points, function (idx, point) {
                        let name = point.series.name,
                            symbolHTML = '<span style="color: ' + point.color + ';">' + symbol + '</span>',
                            id = point.series.userOptions.id,
                            decimals = point.series.userOptions.decimals || 0;

                        switch (id) {
                            // 株価
                            case 'stockPriceDaily':
                            case 'stockPriceWeekly':
                            case 'stockPriceMonthly':
                                tooltip += '<tr><td colspan="2">' + symbolHTML + name + '</td></tr>';
                                tooltip += '<tr><td>' + '　始値：</td><td style="' + numStyle + '">' + Highcharts.numberFormat(point.point.open, decimals, '.', ',') + ' </td></tr>';
                                tooltip += '<tr><td>' + '　高値：</td><td style="' + numStyle + '">' + Highcharts.numberFormat(point.point.high, decimals, '.', ',') + ' </td></tr>';
                                tooltip += '<tr><td>' + '　安値：</td><td style="' + numStyle + '">' + Highcharts.numberFormat(point.point.low, decimals, '.', ',') + ' </td></tr>';
                                tooltip += '<tr><td>' + '　終値：</td><td style="' + numStyle + '">' + Highcharts.numberFormat(point.point.close, decimals, '.', ',') + ' </td></tr>';
                                break;
                            default:
                                tooltipBottom += '<tr><td>' + symbolHTML + name + '：</td><td style="' + numStyle + '">' + Highcharts.numberFormat(point.point.y, decimals, '.', ',') + '</td></tr>';
                        }
                    });

                    tooltip += tooltipBottom + '</table>';

                    return tooltip;
                }
            },
            legend: {
                enabled: false
            },
            exporting: false,
            credits: false,
            plotOptions: {
                series: {
                    showInLegend: false,
                    animation: false,
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        states: {
                            hover: {
                                radius: 4
                            }
                        }
                    },
                    dataGrouping: {
                        enabled: false
                    },
                    states: {
                        inactive: {
                            //ホバーイベントのデフォルトを薄くしない
                            opacity: 1,
                        }
                    }
                },
                candlestick: {
                    color: '#039',
                    lineColor: '#039',
                    upColor: '#f03',
                    upLineColor: '#f03',
                    maxPointWidth: 10,
                    showInLegend: false
                },
                column: {
                    color: '#595959',
                    maxPointWidth: 10,
                    pointPadding: 0.18
                },
                sma: {
                    lineWidth: 1
                },
                bb: {
                    states: {
                        hover: {
                            marker: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            //データ
            series: series
        });
    }

    /**
     * 表示期間を変更する
     *
     * @param {type} rangeId
     *
     * @returns {unresolved}
     */
    setChartRange(rangeId) {
        rangeId = parseInt(rangeId);
        let stimeUnix;

        if (this.chart.series[0].data === undefined) {
            return false;
        }
        // データの最後の日付
        let lastDate = moment.unix(this.chart.series[0].data.slice(-1)[0].x / 1000).format('YYYY-MM-DD');
        switch (rangeId) {
            // 1ヶ月
            case 2:
                stimeUnix = moment(lastDate).add(-1, 'M').add(1, 'd').unix();
                break;
            // 3ヶ月
            case 3:
                stimeUnix = moment(lastDate).add(-3, 'M').add(1, 'd').unix();
                break;
            // 6ヶ月
            case 4:
                stimeUnix = moment(lastDate).add(-6, 'M').add(1, 'd').unix();
                break;
            default:
        }
        // 期間変更
        this.chart.xAxis[0].update({
            min: stimeUnix * 1000
        });
    }
}
